import { Directive, HostBinding, Input, Inject, PLATFORM_ID, OnChanges } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: 'a[href]',
  standalone: false,
})
export class ExternalLinkDirective implements OnChanges {
  @HostBinding('attr.rel') relAttr = '';
  @HostBinding('attr.target') targetAttr = '';
  @HostBinding('attr.href') hrefAttr = '';
  @Input() href: string;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: string) {}

  public ngOnChanges(): void {
    this.hrefAttr = this.href;

    if (this.isLinkExternal) {
      this.relAttr = 'noopener';
      this.targetAttr = '_blank';
    }
  }

  private get isLinkExternal(): boolean {
    return isPlatformBrowser(this.platformId) && !this.href.includes(location.hostname);
  }
}
